import { render, staticRenderFns } from "./IRSForms.vue?vue&type=template&id=25d8916e&scoped=true&"
import script from "./IRSForms.vue?vue&type=script&lang=js&"
export * from "./IRSForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d8916e",
  null
  
)

export default component.exports